import { INotSure } from "@/types";
import { Table, TableProps } from "antd";
import { TablePaginationConfig } from "antd/es/table";
import { memo } from "react";

interface IProps extends TableProps<INotSure> {
  // data: INotSure[];
  // columns: ColumnsType<INotSure>;
  title?: () => string;
  pagination?: TablePaginationConfig | false | undefined;
}

/**
 * @author traj3ctory
 * @function @AppTable
 **/

const AppTable = memo(
  ({ title, className, ...rest }: IProps) => {
    return (
      <Table
        rowKey={(record) => (record?.uid || record?.id || record?._uuid) as string | number}
        title={title}
        className={`mb-4 ${className}`}
        // pagination={pagination}
        {...rest}
      />
    );
  }
);

export default AppTable;
